export default __webpack_public_path__ + "static/media/icon-moon.b3bda0cc.svg";